import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table table-tenant-sm table-hover" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "Id", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["onClick"]

import { ref, onMounted, watch } from "vue";
import {
  EventShopOrderStatusTypes,
  EventShopOrderStatusOptions,
} from "@/core/types/shop/ShopPointsTypes";
import EventsServices from "../../../services/EventsServices";
import OrderDetail from "../OrderDetail.vue";
import AddTrackingModal from "../AddTrackingModal.vue";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserOrders',
  props: {
    partyId: {}
  },
  setup(__props: any) {

const props = __props;

const t = i18n.global.t;
const isLoading = ref(false);
const orderDetailRef = ref<any>(null);
const addTrackingModalRef = ref<any>(null);
const accountSelected = ref(0);

const data = ref(<any>[]);
const criteria = ref<any>({
  page: 1,
  size: 20,
  partyId: props.partyId,
  status: null,
});

const fetchData = async (page: number) => {
  isLoading.value = true;
  criteria.value.page = page;
  try {
    const res = await EventsServices.queryShopOrderList(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.error(error);
  }
  isLoading.value = false;
};

const showDetail = (item: any) => {
  orderDetailRef.value?.show(item);
};

function getStatusTag(status: EventShopOrderStatusTypes) {
  switch (status) {
    case EventShopOrderStatusTypes.Pending:
      return "warning";
    case EventShopOrderStatusTypes.Processing:
      return "info";
    case EventShopOrderStatusTypes.Shipped:
      return "primary";
    case EventShopOrderStatusTypes.Succeed:
      return "success";
    case EventShopOrderStatusTypes.Cancelled:
      return "danger";
  }
}

const getStatusLabel = (value: number) => {
  const option = EventShopOrderStatusOptions.value.find(
    (option) => option.value === value
  );
  return option ? option.label : "";
};

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};
watch(
  () => criteria.value.status,
  () => {
    fetchData(1);
  }
);
onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_ShopPoints = _resolveComponent("ShopPoints")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_select, {
            modelValue: criteria.value.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.status) = $event)),
            placeholder: _ctx.$t('fields.status'),
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EventShopOrderStatusOptions), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_6,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.itemName")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.totalPoints")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operator")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
            }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_tag, {
                          type: getStatusTag(item.status)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getStatusLabel(item.status)), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.eventShopItemName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ShopPoints, {
                          points: item.totalPoint
                        }, null, 8, ["points"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn,
                          type: "GMToneLiner"
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: ($event: any) => (showDetail(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.detail")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ], 10, _hoisted_10))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(OrderDetail, {
      ref_key: "orderDetailRef",
      ref: orderDetailRef
    }, null, 512),
    _createVNode(AddTrackingModal, {
      ref_key: "addTrackingModalRef",
      ref: addTrackingModalRef,
      onFetchData: fetchData
    }, null, 512)
  ], 64))
}
}

})